import { IonFooter } from '@ionic/react';
import React from 'react';
import style from './Footer.module.scss';

const Footer: React.FC = () => {
  return <IonFooter className={style['page-footer']}></IonFooter>;
};

export default Footer;
